import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
function TaskDetail(props) {
  const { task } = props;
  const { auth } = props;

  if (!auth.uid) {
    return <Redirect to="/signin" />;
  } else {
    if (task) {
      return (
        <div className="container section project-details">
          <div className="card z-depth-0">
            <div className="card-content">
              <span className="card-title">{task.title}</span>
              <p>{task.content}</p>
              <div className="card-action gray lighten-4 gray-text">
                <div>
                  posted by {task.firstName} {task.lastName}
                </div>
                <div className="red-text">
                  {task.date.toDate().toDateString()}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div>Loading Project{console.log(props)}</div>;
    }
  }
}
const mapStateToProps = (state, ownProps) => {
  // props are not availabe inside this function since it's outsite the scope of the componet, but you can still access it by passing a second argument

  const id = ownProps.match.params.id;
  const tasks = state.firestore.ordered.tasks;

  // there is a problem with the id I'm grabbing from props, need to check it out later//took me 2 weeks to fix this part, I need to study more
  const singleTask = tasks
    ? state.firestore.ordered.tasks.find((item) => item.id == id)
    : null;

  return {
    task: singleTask,
    auth: state.firebase.auth,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect([{ collection: "tasks" }])
)(TaskDetail);
